import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import {Inject, Component, ViewEncapsulation, ViewChild, ElementRef, AfterViewInit} from '@angular/core';
import { AngularFireStorage } from 'angularfire2/storage';
import { StateService } from 'app/core/state.service';
import { AuthService } from '../../../core/auth.service';
import { Subject } from "rxjs/Subject";
import { firestore } from "firebase"

/**
 * Created by greg on 9/03/2018.
 */

@Component({
    selector: 'new-event-dialog',
    encapsulation: ViewEncapsulation.None,
    template: `
<div class="dialog">
    <div mat-dialog-title><mat-icon (click)="dialogRef.close()">close</mat-icon>New Event</div>
    <div mat-dialog-content >
        <p>You are currently using <b [textContent]="data.active"></b> of your <b [textContent]="data.credits"></b> active events.</p>
        <p>Start by giving your event a name</p>
        <div class="">
            <mat-form-field >
                <input matInput [(ngModel)]="data.the_event.title" (keyup)="submitOnEnter($event)" />
            </mat-form-field>
        </div>
        <div *ngIf="duplicate_with_unique_ids">
            <mat-checkbox color="primary" [(ngModel)]="data.the_event.retain_unique_ids">Retain imported unique IDs for duplicated registrants</mat-checkbox>
        </div>
    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="dialogRef.close()">CANCEL</button>
        <button mat-button color="primary" [mat-dialog-close]="data" [disabled]="!data.the_event.title">NEXT</button>
    </div>
</div>    
`
})
export class NewEventDialog {

    duplicate_with_unique_ids

    constructor( public dialogRef: MatDialogRef<NewEventDialog>, @Inject(MAT_DIALOG_DATA) public data: any) {
        this.duplicate_with_unique_ids = data.the_event.is_duplicate && data.the_event.use_custom_id;
    }

    submitOnEnter(ev) {
        if (ev.keyCode == 13) {
            this.dialogRef.close(this.data)
        }
    }
}


@Component({
    selector: 'populate-new-event-dialog',
    encapsulation: ViewEncapsulation.None,
    template: `
<div class="relative dialog">
    <div mat-dialog-title><mat-icon (click)="dialogRef.close()">close</mat-icon>{{dialog_title}}</div>
    <div mat-dialog-content class="long" >
        <p>These will be used in your invitations and ticket emails. You can fill these out later if you like.</p>
        <form>
            <div *ngIf="data.action == 'update'">
                <label for="title">Title</label>
                <mat-form-field >
                    <input matInput id="title" name="title"  [(ngModel)]="data.the_event.title">
                </mat-form-field>
            </div>
            <label for="date">Event date</label>
            <mat-datepicker-toggle color="primary" [for]="picker"></mat-datepicker-toggle>
            {{data.the_event.formated_date | date:'EEEE d MMMM y'}}
            <mat-form-field class="date_field" >
                <input hidden matInput id="date" name="date" [matDatepicker]="picker" [(ngModel)]="data.the_event.formated_date">
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
            <simple-timepicker label="Start time" [(value)]="data.the_event.start"></simple-timepicker>
            <simple-timepicker label="End time" [(value)]="data.the_event.end"></simple-timepicker>
            <label for="venue">Event Venue</label>
            <mat-form-field >
                <input matInput id="venue" name="venue" [(ngModel)]="data.the_event.venue" >
            </mat-form-field>
            <label for="address">Address</label>
            <mat-form-field >
                <textarea matInput id="address" name="address" [(ngModel)]="data.the_event.address" > </textarea>
            </mat-form-field>
            <label for="url">Venue URL</label>
            <mat-form-field >
                <input matInput id="url" name="url" [(ngModel)]="data.the_event.venue_url" >
            </mat-form-field>
        </form>
    </div>
    <div mat-dialog-actions >
        <button mat-button color="primary" (click)="formatAndSave(data)" 
                [textContent]="data.action"></button>
    </div>
</div>
`,
})
export class PopulateNewEventDialog {

    dialog_title = 'Additional Details';
    constructor( public dialogRef: MatDialogRef<PopulateNewEventDialog>, @Inject(MAT_DIALOG_DATA) public data: any ) {
        data.the_event.formated_date = data.the_event.date ? data.the_event.date.toDate() : new Date();
        if (data.action == 'update') {
            this.dialog_title = 'Edit Event';
            data.the_event.previous_date = data.the_event.formated_date;
        }
    }
    formatAndSave(data) {
        const dd = data.the_event.formated_date.setHours(0,0,0,0);
        data.the_event.date = firestore.Timestamp.fromDate(new Date(dd));
        this.dialogRef.close(data);
    }
}



@Component({
    selector: 'delete-event-dialog',
    encapsulation: ViewEncapsulation.None,
    template: `
<div class="dialog">
    <div mat-dialog-title class="warning" ><mat-icon (click)="dialogRef.close()">close</mat-icon>Delete Event</div>
    <div mat-dialog-content >
        Are you sure you want to delete <strong>{{data.evnt.title}}?</strong> This will delete all information inside this event, 
        including any history of emails sent or check-in status.</div>
    <div mat-dialog-actions >
        <button mat-button (click)="dialogRef.close()">Cancel</button>
        <button mat-button [mat-dialog-close]="data" color="primary" >Remove</button>
    </div>
</div>    
`,
})
export class DeleteEventDialog {
    constructor( public dialogRef: MatDialogRef<DeleteEventDialog>, @Inject(MAT_DIALOG_DATA) public data: any) { }
}
@Component({
    selector: 'close-event-dialog',
    encapsulation: ViewEncapsulation.None,
    template: `
<div class="dialog">
    <div mat-dialog-title class="warning" ><mat-icon (click)="dialogRef.close()">close</mat-icon>Close Event</div>
    <div mat-dialog-content >
        Are you sure you want to close <strong>{{data.evnt.title}}?</strong> 
        You will be able to access the information but not make any updates. This action is final.</div>
    <div mat-dialog-actions >
        <button mat-button (click)="dialogRef.close()">Cancel</button>
        <button mat-button [mat-dialog-close]="data" color="primary" >Close Event</button>
    </div>
</div>    
`,
})
export class CloseEventDialog {
    constructor( public dialogRef: MatDialogRef<CloseEventDialog>, @Inject(MAT_DIALOG_DATA) public data: any) { }
}



@Component({
    selector: 'registrant-dialog',
    encapsulation: ViewEncapsulation.None,
    template: `
<div class="edit_dialog dialog">
    <div mat-dialog-title><mat-icon (click)="dialogRef.close()">close</mat-icon>{{is_new ? 'Add' : 'Edit'}}</div>
    <form mat-dialog-content >
        <div *ngIf="show_scanId">
            <label for="scanId">Custom Unique Id *</label>
            <mat-form-field >
                <input matInput name="scanId" [(ngModel)]="data.registrant.scanId" required>
            </mat-form-field>
        </div>
        <label for="email">Email *</label>
        <mat-form-field >
            <input matInput name="email" [(ngModel)]="data.registrant.email" required>
            <mat-error *ngIf="!data.registrant.email">
                Email is <strong>required</strong>
            </mat-error>
        </mat-form-field>
        <label for="firstName">First Name *</label>
        <mat-form-field >
            <input matInput name="firstName" [(ngModel)]="data.registrant.firstName" required>
            <mat-error *ngIf="!data.registrant.firstName">
                First name is <strong>required</strong>
            </mat-error>
        </mat-form-field>
        <label for="lastName">Last Name *</label>
        <mat-form-field >
            <input matInput name="lastName" [(ngModel)]="data.registrant.lastName" required>
            <mat-error *ngIf="!data.registrant.lastName">
                Last name is <strong>required</strong>
            </mat-error>
        </mat-form-field>
        <label for="company">Company</label>
        <mat-form-field class="w-full">
            <input matInput name="company"  [(ngModel)]="data.registrant.company" >
        </mat-form-field>
        <label for="phone">Phone</label>
        <mat-form-field class="w-full">
            <input matInput name="phone"  [(ngModel)]="data.registrant.phone" >
        </mat-form-field>
        <label for="attending">Attendance</label>
        <mat-radio-group name="attending" [(ngModel)]="data.registrant.attending">
            <mat-radio-button color="primary" *ngFor="let opt of attending_opt" [value]="opt.value">
                {{opt.label}}
            </mat-radio-button>
        </mat-radio-group>
        <div class="spacer">
            <mat-slide-toggle color="primary" name="checkedIn" [(ngModel)]="data.registrant.checkedIn">Checked in</mat-slide-toggle>
        </div>
        <div class="spacer">
            <mat-slide-toggle color="primary" name="walkin" [(ngModel)]="data.registrant.walkin">Walk-in</mat-slide-toggle>
        </div>
    </form>
    <div mat-dialog-actions >
        <button mat-button (click)="onNoClick()">Cancel</button>
        <button mat-button [mat-dialog-close]="data" color="primary"
                [disabled]="!data.registrant.email || !data.registrant.firstName || !data.registrant.lastName">Save</button>
    </div>
</div>`,
    styles: [`
    .edit_dialog .spacer { margin: 10px 0; }
    .edit_dialog .mat-radio-group { display: inline-flex; flex-direction: column; margin: 5px 0 10px; }
    .edit_dialog .mat-radio-group  label { display: flex; align-items: center; }
    `]
})
export class RegistrantDialogComponent {

    is_new = false;
    show_scanId = false;
    attending_opt = [{label: 'Pending', value: 'pending'}, {label: 'Attending', value: 'accepted'},
        {label: 'Not attending', value: 'declined'}];

    constructor( public dialogRef: MatDialogRef<RegistrantDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any ) {
        this.is_new = !data.registrant.hasOwnProperty('registrantId');
        if (data.evnt.use_custom_id) {
            this.show_scanId = true;
        }
        // console.log('data.evnt', data.evnt);
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

}


@Component({
    selector: 'custom-uids',
    encapsulation: ViewEncapsulation.None,
    template: `
<div class="custom_uids_dialog dialog">
    <div mat-dialog-title class="warning"><mat-icon (click)="dialogRef.close()">close</mat-icon>{{title}}</div>
    <div mat-dialog-content >
        {{body}}
    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="dialogRef.close()">Cancel</button>
        <button mat-button [mat-dialog-close]="data" color="primary" >{{button_text}}</button>
    </div>
</div>
`
})
export class CustomUidsDialog {
    title;
    button_text;
    body;
    amount;
    constructor( public dialogRef: MatDialogRef<DeleteRegistantDialog>, @Inject(MAT_DIALOG_DATA) public data: any ) {
        switch(data.type) {
            case 'restore':
                const registrants = (data.amount == 1) ? "your registrant's" : "all of your " + data.amount + " registrants'" ;
                this.title = 'Confirm Unique ID Restoration';
                this.body = 'If you proceed, then ' + registrants + ' unique identifiers will be replaced with Checkit system unique identifiers. This action cannot be undone.';
                this.button_text = 'Restore Now';
                break;
            case 'customize':
                this.title = 'Confirm Custom Unique ID';
                this.body = 'If you proceed, then your event will no longer use the system unique identifiers, but instead, will use the unique identifiers that you have imported.';
                this.button_text = 'Use Custom Unique IDs';
                break;
        }
    }
}


@Component({
    selector: 'delete-registrant-dialog',
    encapsulation: ViewEncapsulation.None,
    template: `
<div class="remove_dialog dialog">
    <div mat-dialog-title class="warning"><mat-icon (click)="dialogRef.close()">close</mat-icon>{{title}}</div>
    <div mat-dialog-content >
        Are you sure you want to remove <strong>{{user_name}} </strong> from this event? 
        This will delete all of their information including any history of emails sent or check-in status.
    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="dialogRef.close()">Cancel</button>
        <button mat-button [mat-dialog-close]="data" color="primary" >{{button_text}}</button>
    </div>
</div>
`
})
export class DeleteRegistantDialog {
    title = 'Remove';
    button_text = 'Remove';
    user_name: string;

    constructor( public dialogRef: MatDialogRef<DeleteRegistantDialog>, @Inject(MAT_DIALOG_DATA) public data: any ) {
        if (typeof data.registrant == 'string' && data.registrant == 'all') {
            this.title = 'Remove All';
            this.button_text = 'Remove all';
            this.user_name = 'all delegates';
        } else {
            this.user_name = data.registrant.firstName + ' ' + data.registrant.lastName;
        }
    }
}




@Component({
    selector: 'email-edit-dialog',
    encapsulation: ViewEncapsulation.None,
    template: `
<div class="dialog">
    <div mat-dialog-title><mat-icon (click)="dialogRef.close()">close</mat-icon>Edit {{capitalizeFirstLetter(data.type)}}</div>
    <form mat-dialog-content class="email_content long">
        <div class="drop_panel">
            <div class="square">
                <label for="input-logo-id">
                    <div id="drop_zone" (drop)="onFileChange($event)" (dragover)="dragover($event)">
                        <div *ngIf="!uploading; else loading">
                            <div *ngIf="email.logo; else description">
                                <img [src]="email.logo" />
                            </div>
                        </div>
                    </div>
                </label>
            </div>
            <input type="file" id="input-logo-id" hidden (change)="onFileChange($event)" accept=".jpeg,.jpg">
        </div>
        <div class="upload_error" *ngIf="upload_error">{{upload_error}}</div>
        <div class="remove" *ngIf="email.logo">
            <div *ngIf="!removing; else confirm"><button mat-button (click)="removing=true" tabindex="-1">Remove</button></div>
        </div>
        
        <label for="sender" [ngClass]="{space:!email.logo}">Sender's name</label>
        <mat-form-field >
            <input matInput id="sender" name="sender" [(ngModel)]="email.sender" required />
        </mat-form-field>
        <label for="subject">Subject line</label>
        <mat-form-field >
            <input matInput id="subject" name="subject" [(ngModel)]="email.subject" required />
        </mat-form-field>
        <label for="body">Body</label>
        <mat-form-field >
            <textarea matInput id="body" name="body" [(ngModel)]="email.body" required maxlength="512"></textarea>
            <mat-hint align="end">
                <span aria-live="polite">{{email.body.length}} / 512</span>
            </mat-hint>
        </mat-form-field>
    </form>
    <div mat-dialog-actions>
        <button mat-button (click)="dialogRef.close()">Cancel</button>
        <button mat-button (click)="save()" color="primary" >Save</button>
    </div>
</div>
<ng-template #loading>
    <mat-spinner [diameter]="40"></mat-spinner>
</ng-template>
<ng-template #description>
    <mat-icon>file_upload</mat-icon>
    <div>Drag & drop<br />or click here to upload your logo<br /><span>JPG only, max 610x610px, 200kb</span></div>
</ng-template>
<ng-template #confirm>
    <div class="confirm">
        <span>Remove logo?</span>
        <button mat-button (click)="remove_logo()">Yes</button>
        <button mat-button (click)="removing=false">No</button>
    </div>
</ng-template>
`,
    styles: [`
        .email_content .remove { text-align:right; }
        .email_content .remove .mat-button { color:#999; min-width:initial; }
        .email_content .remove .confirm { display:flex; color: #EE2255; align-items: center; justify-content: flex-end; }
        .email_content .upload_error {text-align: center;	font-size: 12px;	color: #f00;	padding-top: 5px;}
        .email_content .drop_panel { background: #EEF2F5; border-radius:5px; overflow:hidden;text-align:center; }
        .email_content .drop_panel .square { padding:10px; }
        .email_content .drop_panel label mat-icon { color:#999; font-size:48px; width:48px; height:48px; }
        .email_content .drop_panel label span { color:#999; }
        .email_content .space { margin-top:1.25em; }
        .email_content .drop_panel label { background: #EEF2F5; display: block; font-family: Ubuntu;
            font-size: 14px; color: #333; border:2px dashed #ddd; border-radius:5px; }
        .email_content .drop_panel label #drop_zone { padding: 10px 0; display: flex; 
            align-items: center; justify-content: center; min-height: 120px;}
        .email_content .drop_panel label #drop_zone img { max-width:610px; max-height:610px; }
        .email_content button.mat-button { font-family: Ubuntu; font-size: 14px; }
`]
})
export class EmailEditDialogComponent {
    original_email: any;
    email: any;
    uploading = false;
    targetFile: File;
    removing = false;
    upload_error;

    constructor(public dialogRef: MatDialogRef<EmailEditDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
                private state: StateService, private storage: AngularFireStorage, private auth: AuthService, ) {
        this.original_email = JSON.parse(JSON.stringify(data.email));
        this.email = data.email;
    }
    dragover(ev) {
        ev.preventDefault();
    }
    remove_logo() {
        console.log('removing');
        let filename = '';
        this.email.logo = '';
        this.original_email.logo = '';
        const ref = this.auth.afs.doc(`accounts/${this.state.accounts['currentId']}/events/${this.state.checkit.event['eventId']}`);
        if (this.data.type == 'invitation') {
            ref.update({invitationMail: this.original_email});
            filename = this.state.checkit.event['eventId'] + '-invitation-logo.png';
        } else if (this.data.type == 'ticket') {
            ref.update({ticketMail: this.original_email});
            filename = this.state.checkit.event['eventId'] + '-ticket-logo.png';
        }
        this.storage.ref(`accounts/${this.state.accounts['currentId']}/logo/${filename}`)
            .delete().subscribe( x => console.log(x));
    }
    onFileChange(ev: any) {
        this.upload_error = '';
        ev.preventDefault();
        if (ev.dataTransfer && ev.dataTransfer.files.length == 1) {
            this.targetFile = ev.dataTransfer.files[0];
        } else if (ev.target.files && ev.target.files.length == 1 ) {
            this.targetFile = ev.target.files[0];
        } else {
            throw new Error('Cannot use multiple files');
        }
        console.log('this.targetFile ',this.targetFile)
        if(this.targetFile.size > 200000){
            this.upload_error = 'The file size exceeds the 200kb limit';
        }else{
            const reader = new FileReader();
            const self = this;
            reader.onload = function (file) {
                self.email.logo = this.result;
            };
            reader.readAsDataURL(this.targetFile);
        }
    }
    save() {
        if (this.targetFile) {
            this.uploading = true;
            let filename = '';
            if (this.data.type == 'invitation') {
                filename = this.state.checkit.event['eventId'] + '-invitation-logo.png';
            } else if (this.data.type == 'ticket') {
                filename = this.state.checkit.event['eventId'] + '-ticket-logo.png';
            }
            this.storage.upload(`accounts/${this.state.accounts['currentId']}/logo/${filename}`,
                this.targetFile).then().then(x => {
                this.email.logo = x.downloadURL;
                this.uploading = false;
                this.dialogRef.close(this.email);
            })
        } else {
            this.dialogRef.close(this.email);

        }
    }
    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
}




@Component({
    selector: 'preview-dialog',
    encapsulation: ViewEncapsulation.None,
    template: `
<div class="dialog">
    <div mat-dialog-title><mat-icon (click)="dialogRef.close()">close</mat-icon>{{title}}</div>
    <div mat-dialog-content class="iframe long">
        <div class="header">
            <div class="col"><span>From:</span><b>{{data.email_obj.sender}}</b></div>
            <div style="flex:0.1"></div>
            <div class="col"><span>Subject:</span><b>{{data.email_obj.subject}}</b></div>
        </div>
        <iframe #iframe frameborder="0" width="100%" height="480"></iframe>
    </div>
    <div mat-dialog-actions *ngIf="action == 'preview'">
        <button mat-button  color="primary" class="btn" [mat-dialog-close]="{cmd:'send_test'}" tabindex="-1">Send test to yourself</button>
        <div style="flex:1"></div>
        <button mat-button [mat-dialog-close]="{cmd:'edit'}" color="primary" tabindex="-1">Edit {{data.type}}</button>
        <button mat-button color="primary" (click)="dialogRef.close()">Done</button>
    </div>
    <div mat-dialog-actions *ngIf="action == 'send'">
        <button mat-button  color="primary" class="btn" [mat-dialog-close]="{cmd:'send_test'}" tabindex="-1">Send test to yourself</button>
        <div style="flex:1"></div>
        <div *ngIf="selected_num>0">Send {{data.type}}{{selected_num == 1 ? '' : 's'}} to {{selected_num}} people?</div>
        <div *ngIf="selected_num==0">No recipients selected</div>
        <button mat-button [mat-dialog-close]="{cmd:'send'}" class="send" [disabled]="selected_num==0">Send Now</button>
    </div>
    <div mat-dialog-actions *ngIf="action == 'send_one'">
        <button mat-button  color="primary" class="btn" [mat-dialog-close]="{cmd:'send_test'}" tabindex="-1">Send test to yourself</button>
        <div style="flex:1"></div>
        <div>Send {{data.type}} to {{data.reg.firstName}} {{data.reg.lastName}}?</div>
        <button mat-button [mat-dialog-close]="{cmd:'send_one'}" class="send">Send Now</button>
    </div>
</div>
`,
    styles: [`
        .dialog [mat-dialog-content] .header { display:flex; height: 80px; align-items: center; margin: 0 25px; line-height: 17px;
            border-bottom: 1px solid #eee; }
        .dialog [mat-dialog-content] .header .col { display:flex; flex-direction: column; }
        .dialog [mat-dialog-content] .header .col:first-child { width:30%; }
        .dialog [mat-dialog-actions] { font-family: Ubuntu; font-size: 16px; align-items: center; }
        .dialog [mat-dialog-actions] button { height:30px; font-size: 14px; line-height: 14px; }
        .dialog [mat-dialog-actions] .btn { border: 1px solid #ddd; border-radius:15px; margin-left: 20px; }
        .dialog [mat-dialog-actions] button.send:disabled { color: #fff; background: #ddd; }
        .dialog [mat-dialog-actions] button.send { color: #fff; background: #2255FF; line-height: 50px; height: 50px;
            padding: 0 30px; border-radius: 25px; margin-left: 25px; letter-spacing: 1px; font-size: 16px;}
        .dialog iframe { display:block; }
`]
})
export class PreviewDialogComponent implements AfterViewInit {
    title = this.capitalizeFirstLetter(this.data.type);
    @ViewChild('iframe') iframe: ElementRef;
    selected_num = 0;
    action = '';
    value = 0;

    constructor(public dialogRef: MatDialogRef<PreviewDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any ) {
        if (data.action == 'preview') {
            this.title = this.capitalizeFirstLetter(data.type) + ' Preview';
        } else if (data.action == 'send') {
            this.title = 'Send ' + this.capitalizeFirstLetter(data.type) + 's';
        }
        this.action = data.action;
        this.selected_num = data.selected_num;
    }
    ngAfterViewInit() {
        const doc = this.iframe.nativeElement.contentDocument || this.iframe.nativeElement.contentWindow;
        doc.open();
        doc.write(this.data.html);
        doc.close();
    }
    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
}



@Component({
    selector: 'new-limit-dialog',
    encapsulation: ViewEncapsulation.None,
    template: `
<div class="dialog">
    <div mat-dialog-title><mat-icon (click)="dialogRef.close()">close</mat-icon>Limit Reached</div>
    <div mat-dialog-content >
        <p>You've used up all of your <b [textContent]="data.credits"></b>
            active events! Delete an event or upgrade your subscription to create more.</p>
    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="dialogRef.close()" tabindex="-1">CANCEL</button>
        <button mat-button color="primary" mat-dialog-close="upgrade">Upgrade Subscription</button>
    </div>
</div>    
`
})
export class OverLimitDialogComponent {
    constructor( public dialogRef: MatDialogRef<OverLimitDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }
}

@Component({
    selector: 'checkin-information',
    encapsulation: ViewEncapsulation.None,
    template: `
<div class="dialog">
    <div mat-dialog-title><mat-icon (click)="dialogRef.close()">close</mat-icon>Check-In Information</div>
    <div mat-dialog-content >
        <collapsible>
            <div collapsible-toggle><div class="toggler">How check in works?</div></div>
            <div collapsible-content>Check people into your event on your mobile through the checkit app.</div>
        </collapsible>
        <collapsible>
            <div collapsible-toggle><div class="toggler">What can you do with the Checkit App?</div></div>
            <div collapsible-content>Scan QR / bar codes<br/>
                Search names and mark attendance<br/>
                Enter details of walk ins</div>
        </collapsible>
        <collapsible>
            <div collapsible-toggle><div class="toggler">How do I get the Checkit App?</div></div>
            <div collapsible-content>The <i>set up check in</i> email has a link to download the app
                Download once and you can use it on all checkit events.</div>
        </collapsible>
        <collapsible>
            <div collapsible-toggle><div class="toggler">I am doing the check in</div></div>
            <div collapsible-content>Send the <i>set up check in</i> email to yourself and click on the link to the event.</div>
        </collapsible>
        <collapsible>
            <div collapsible-toggle><div class="toggler">Someone else is doing the check in</div></div>
            <div collapsible-content>Anyone can check in for you. Simply send them the <i>set up check in</i> 
                email and follow the instructions.</div>
        </collapsible>
        <collapsible>
            <div collapsible-toggle><div class="toggler">Can more than one person do the check in?</div></div>
            <div collapsible-content>You can have as many people as you want doing the check in.<br/>
                All the data goes back to the one event dashboard in real time.</div>
        </collapsible>
        <collapsible>
            <div collapsible-toggle><div class="toggler">Do I get real time reports?</div></div>
            <div collapsible-content>The event dashboard is updated in real time.<br/>
                You can log into your checkit account a view the dashboard on any device; it’s really mobile friendly.</div>
        </collapsible>
        <collapsible>
            <div collapsible-toggle><div class="toggler">Is my data safe?</div></div>
            <div collapsible-content>The checkit app is designed so the people doing the check in only see first name and 
                last name of attendees. They cannot see the event dashboard and cannot copy or download data. 
                So yes, your data is safe.</div>
        </collapsible>
       
    </div>
</div>
`,
    styles: [`
        .dialog .mat-dialog-content { padding:0; }
        collapsible { border-bottom: 1px solid #ddd; center; display: block; padding: 30px 24px; font-size: 16px;}
        .toggler { font-weight: bold; cursor: pointer; }
`]
})
export class CheckinInformationDialogComponent {
    constructor(public dialogRef: MatDialogRef<CheckinInformationDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }
}


@Component({
    selector: 'progress-message',
    encapsulation: ViewEncapsulation.None,
    template: `
        <div class="dialog">
            <div mat-dialog-title [style.background]="titleBgColor">
                <mat-icon *ngIf="action=='success'" (click)="dialogRef.close()">close</mat-icon>
                {{title}}
            </div>
            <div mat-dialog-content>
                <div class="message">{{message}}</div>
                <div class="processing" *ngIf="action=='progress'">
                    <div class="progress-bar"><div class="ratio" [ngStyle]="{width: value + '%'}"></div></div>
                </div>
            </div>
            <div mat-dialog-actions *ngIf="action=='success'">
                <button mat-button color="primary" (click)="dialogRef.close()">{{data.buttonText}}</button>
            </div>
        </div>
    `,
    styles: [`
        .dialog [mat-dialog-content] .message { margin-bottom: 10px; }
        .dialog [mat-dialog-content] .progress-bar { width:100%; height:10px; border-radius:5px; background:rgba(34,85,255,0.2); }
        .dialog [mat-dialog-content] .ratio { width:5px; height:10px; border-radius:5px; background:rgba(34,85,255,1); }
    `]
})
export class ProgressMessageDialogComponent {

    value = 0;
    action = 'progress';
    titleBgColor = '#25f';
    title = '';
    message = ''
    prepare_progress = new Subject<any>();

    constructor(public dialogRef: MatDialogRef<ProgressMessageDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
        this.title = data.title;
        this.message = data.message;
        this.prepare_progress.subscribe( x => {
            this.value = x.value;
            if (x.value == 100) {
                setTimeout( _ => {
                    this.action = 'success';
                    this.title = x.title;
                    this.message = x.message;
                    this.titleBgColor = '#0e9';
                }, 200)
            }
        });
        this.prepare_progress.next({value: 50});
        if (data.titleBgColor) {
            this.titleBgColor = data.titleBgColor;
        }
        if (data.action) {
            this.action = data.action;
        }
    }
}



@Component({
    selector: 'send-test',
    encapsulation: ViewEncapsulation.None,
    template: `
        <div class="dialog">
            <div mat-dialog-title><mat-icon (click)="dialogRef.close()">close</mat-icon>Send Test</div>
            <div mat-dialog-content>
                <p>The test email will be sent to:<br/><b>{{data.fullname}} ({{data.email}})</b></p>
                <p>Your details will be added to the guest list so you can test the RSVP and check-in functions.</p>
            </div>
            <div mat-dialog-actions>
                <button mat-button (click)="dialogRef.close()">Cancel</button>
                <button mat-button color="primary" [mat-dialog-close]="{cmd:'send'}">{{data.buttonText}}</button>
            </div>

        </div>
    `,
    styles: [`
        .dialog [mat-dialog-content] { padding: 40px 60px 40px;line-height: 20px;}
        .dialog [mat-dialog-actions] button { font-size:16px; }
    `]
})
export class SendTestDialogComponent {
    constructor( public dialogRef: MatDialogRef<SendTestDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }
}




@Component({
    selector: 'send-test',
    encapsulation: ViewEncapsulation.None,
    template: `
<div class="dialog">
    <div mat-dialog-title><mat-icon (click)="dialogRef.close()">close</mat-icon>Select Recipients</div>
    <div mat-dialog-content>
        <p>Who would you like your invitation to be sent to?</p>
        <mat-select (change)="change($event)" placeholder="Select">
            <mat-option *ngFor="let opt of options" [value]="opt.value" >{{opt.label}}</mat-option>
        </mat-select>
    </div>
    <div mat-dialog-actions>
        <button mat-button color="primary" [mat-dialog-close]="value">Select recipients</button>
    </div>

</div>
`,
    styles: [`
        .dialog [mat-dialog-content] { padding: 40px 60px 40px; line-height: 20px;}
        .dialog [mat-dialog-content] mat-select { background:#EEF2F5; height:50px; padding:15px 10px; }
        .dialog [mat-dialog-actions] button { font-size:16px; }
`]
})
export class RecipientsDialogComponent {
    options = [];
    value = ''
    constructor( public dialogRef: MatDialogRef<RecipientsDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
        this.options = [{value: 'all', label: 'Select All ('+this.data.stats.list_count+')'},
            {value: 'invited', label: 'Select Invited ('+this.data.stats.invited+')'},
            {value: 'not-invited', label: 'Select Not Invited ('+(this.data.stats.list_count - this.data.stats.invited)+')'},
            {value: 'attending', label: 'Select Attending ('+(this.data.stats.attending)+')'},
            {value: 'not-attending', label: 'Select Not Attending ('+(this.data.stats.list_count - this.data.stats.attending)+')'},
            {value: 'checked-in', label: 'Select Checked In ('+(this.data.stats.checkedIn)+')'},
            {value: 'not-checked-in', label: 'Select Not Checked In ('+(this.data.stats.list_count - this.data.stats.checkedIn)+')'},
            {value: 'walkups', label: 'Select Walk Ups ('+(this.data.stats.walk_ins)+')'}];
    }
    change(ev) {
        this.value = ev.value;
    }
}




// WEBPACK FOOTER //
// ./src/app/pages/checkit-dashboard/components/dialogs.ts